/**
 * @param {Object} simulation simulation.json data
 */
export const allowMobileOutlineToggle = simulation => simulation?.featureFlags?.allowMobileOutlineToggle

const featureFlags = { allowMobileOutlineToggle }
export default featureFlags
